import { styled, Tooltip, type TooltipProps, tooltipClasses } from '@mui/material'

export const WarnTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.vars.palette.error.dark,
    boxShadow: theme.vars.shadows[1],
    color: theme.vars.palette.tidalColors.cloudGray[50],
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.vars.palette.error.dark,
  },
}))
